import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE } from 'constants/General'

import { getFromStorage, UNITE_LANGUAGE_KEY } from './constants/LocalStorage'
// translation files
import en from './translations/en.json'
import es from './translations/es.json'
import pt from './translations/pt.json'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    interpolation: {
      escapeValue: false, // react already safes from xss
      format(value, format) {
        if (format === 'call-format' && value instanceof Date) {
          const time = new Intl.DateTimeFormat('default', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          }).format(value)

          return `${value.getDate()}, ${value.getFullYear()} @ ${time}`
        }
        if (format === 'call-day' && value instanceof Date) {
          return value.getDay()
        }
        if (format === 'call-month' && value instanceof Date) {
          return value.getMonth()
        }
        return value
      },
    },
    lng: getFromStorage(UNITE_LANGUAGE_KEY) || DEFAULT_LOCALE, // default language
    fallbackLng: DEFAULT_LOCALE,
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
    },
  })

export default i18n
